<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-item label="医生名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['docName']" placeholder="请输入医生名称"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24" v-show="showCopyLink">
            <a-form-item label="复制链接" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-button class="ant-btn ant-btn-primary"  v-clipboard:copy="copyLink" v-clipboard:success="onCopyUrl"  v-clipboard:error="onErrorUrl">复制链接</a-button>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="科室名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <!-- <a-input v-decorator="['departmentName']" placeholder="请输入科室名称"></a-input> -->
              <!-- departmentNameList -->
              <a-select style="width: 100%" @change="handleSelectChange" v-decorator="['departmentName']" >
                <a-select-option v-for="(item, index) in departmentNameList" :key="index" :value="item.departmentName">
                  {{ item.departmentName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="头衔" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['title']" placeholder="请输入头衔"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="优秀专家" :labelCol="labelCol" :wrapperCol="wrapperCol">
               <a-select v-decorator="['isExcellent']" placeholder="请选择是否是优秀专家" @change="isExcellentChange">
                <a-select-option :value="'Y'">是</a-select-option>
                <a-select-option :value="'N'">否</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="24"  v-if="excellentShow == true">
            <a-form-item label="优秀专家照片" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <div style="text-align: left;">宽650px、高400px</div>
              <j-image-upload isMultiple v-decorator="['excellentDoctorUrl']" :maxWidth="'650px'" :maxHeight="'400px'"></j-image-upload>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="标签" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['labelName']" placeholder="请输入标签"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="半身照" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-image-upload isMultiple v-decorator="['bustUrl']"></j-image-upload>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="擅长" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['skill']" placeholder="请输入擅长"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="职称" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['jobTitle']" placeholder="请输入职称"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="二维码" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-image-upload isMultiple v-decorator="['qrCodeUrl']"></j-image-upload>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="师承" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['learnFrom']" placeholder="请输入师承"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="医生简介" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-editor v-decorator="['doctorIntroduction',{trigger:'input'}]"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="排序" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['sort']" placeholder="请输入排序" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="有效" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-switch v-decorator="['isEffective']" ></j-switch>
            </a-form-item>
          </a-col>
          <a-col v-if="showFlowSubmitButton" :span="24" style="text-align: center">
            <a-button @click="submitForm">提 交</a-button>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import JImageUpload from '@/components/jeecg/JImageUpload'
  import JEditor from '@/components/jeecg/JEditor'
  import JSwitch from '@/components/jeecg/JSwitch'

  export default {
    name: 'WebsiteDoctorForm',
    components: {
      JFormContainer,
      JImageUpload,
      JEditor,
      JSwitch,
    },
    props: {
      //流程表单data
      formData: {
        type: Object,
        default: ()=>{},
        required: false
      },
      //表单模式：true流程表单 false普通表单
      formBpm: {
        type: Boolean,
        default: false,
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        form: this.$form.createForm(this),
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
        },
        url: {
          add: "/zyWebsite/websiteDoctor/add",
          edit: "/zyWebsite/websiteDoctor/edit",
          queryById: "/zyWebsite/websiteDoctor/queryById",
          department:'/zyWebsite/websiteDepartment/list'
        },
        departmentNameList:[],
        excellentShow:false,
        copyLink:'',
        showCopyLink:true
      }
    },
    computed: {
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return true
          }
        }
        return false
      }
      
    },
    created () {
      //如果是流程中表单，则需要加载流程表单data
      this.departmentList();
      this.showFlowData();
     
    },
    methods: {
      onCopyUrl() {
        this.$message.success("复制成功!");
      },
      onErrorUrl() {
        this.$message.error("复制失败!");
      },
      //是优秀专家 显示上传专家图片
      isExcellentChange(e){
        if(e === "Y"){
            this.excellentShow = true;
        }else{
            this.excellentShow = false;
        }
      },
      add () {
        this.showCopyLink = false
        if(this.model.isExcellent === "Y"){
            this.excellentShow = true;
        }else{
            this.excellentShow = false;
        }
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'docName','docId','departmentName','bustUrl','departmentId','sort','learnFrom','introduction','isExcellent','excellentDoctorUrl','jobTitle','labelName','logo','skill','title','qrCodeUrl','doctorIntroduction','isEffective','isEffectiveName'))
        })
        this.copyLink = 'https://bjzyzyy.net/doctor?departmentId='+this.model.departmentId+'&docId='+this.model.docId
        if(this.model.isExcellent === "Y"){
          this.form.isExcellent = "Y"
          this.excellentShow = true;
        }else{
          this.form.isExcellent = "N"
          this.excellentShow = false;
        }
      },
      departmentList(){
        getAction(this.url.department).then((res)=>{
            if(res.success){
              this.departmentNameList = res.result.records
            }
          });
      },
      handleSelectChange(value){
        this.departmentNameList.forEach((item,index) => {
          if(item.departmentName == value){
            this.model.departmentId = item.departmentId
          }
        });
      },
      //渲染流程表单数据
      showFlowData(){
        if(this.formBpm === true){
          let params = {id:this.formData.dataId};
          getAction(this.url.queryById,params).then((res)=>{
            if(res.success){
              this.edit (res.result);
            }
          });
        }
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            let formData = Object.assign(this.model, values);
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }
         
        })
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'docName','docId','departmentName','departmentId','sort','bustUrl','learnFrom','introduction','isExcellent','excellentDoctorUrl','jobTitle','labelName','logo','skill','title','qrCodeUrl','doctorIntroduction','isEffective','isEffectiveName'))
      },
    }
  }
</script>